export type Settings = {
  settingsId: string,
  channels: Channel[]
};

export type Channel = {
  channel: ChannelType,
  activated: boolean,
  address?: string,
  deactivationReason?: string,
  verificationCode?: string,
};

export enum ChannelType {
  EMAIL = 'email',
  DIIA = 'diia',
}

export type ChannelDto = Pick<Channel, 'address'>;
